import React, { createContext, useState, useContext, useMemo, useEffect } from 'react';
import { getUserIPCountryLanguage, getLocaleForCountry, isPrivateIP } from '../utils/geoLanguage';

// Import translation files
import en from '../locales/en-US.json';
import pt from '../locales/pt-BR.json';
import es from '../locales/es-419.json';

const translations = { 'en-US': en, 'pt-BR': pt, 'es-419': es };

const LocalizationContext = createContext();

export const LocalizationProvider = ({ children }) => {
  const [locale, setLocale] = useState('en-US');
  const [userChanged, setUserChanged] = useState(false);

  // Auto-detect on mount only if user hasn't changed language
  useEffect(() => {
    if (userChanged) return;
    (async () => {
      const { ip, country } = await getUserIPCountryLanguage();
      if (isPrivateIP(ip)) {
        setLocale('en-US');
      } else {
        setLocale(getLocaleForCountry(country));
      }
    })();
  }, [userChanged]);

  // Patch setLocale to mark user intent
  const setLocaleWithUserFlag = (code, user = false) => {
    setLocale(code);
    if (user) setUserChanged(true);
  };

  const t = useMemo(() => {
    return (key) => {
      return translations[locale][key] || translations['en-US'][key] || key;
    };
  }, [locale]);

  return (
    <LocalizationContext.Provider value={{ locale, setLocale: (code) => setLocaleWithUserFlag(code, true), t }}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => useContext(LocalizationContext);
